export const API_URL = 'https://dashboard.mybikecounter.com';
export const API_PORT = 443;

export const WS_URL = 'ws://dashboard.mybikecounter.com';
export const WS_PORT = 8020;
